jQuery(".menu-opener").click(function () {
  jQuery(this).toggleClass("open");
  jQuery(".mbl_navigation").toggleClass("active");
  jQuery("body").toggleClass("active");
});

jQuery(".mbl_navigation ul li.menu-item-has-children>a").click(function (e) {
  e.preventDefault();
  jQuery(this).closest("li").find(">.sub-menu").toggleClass("active");
});
if (jQuery(".radios").length) {
  window.onload = function () {
    // Check localStorage for a selected variant
    var selectedVariantId = localStorage.getItem("selectedVariantId");
    if (selectedVariantId) {
      // If a variant is stored, select that radio button
      var radioButton = document.getElementById("variant-" + selectedVariantId);
      if (radioButton) {
        radioButton.checked = true;
      }
    } else {
      // If no variant is stored, select the first one by default (already done in HTML)
      // This is just to ensure clarity, as the first one is already checked
    }

    // Add event listeners to the radio buttons
    var radioButtons = document.querySelectorAll('input[name="id"]');
    radioButtons.forEach(function (radio) {
      radio.addEventListener("change", function () {
        // Store the selected variant in localStorage
        localStorage.setItem("selectedVariantId", this.value);
      });
    });
  };
}

$(".radios label").click(function () {
  // Get the data-variant-quantity attribute of the clicked label
  var variantQuantity = $(this).data("variant-quantity");
  $("#stockMessage span").text(variantQuantity);
  console.log(variantQuantity); // Output the value to the console
});

const pollerLite = (conditions, callback, maxTime = 1000000) => {
  const POLLING_INTERVAL = 25;
  const startTime = Date.now();
  const interval = setInterval(() => {
    const allConditionsMet = conditions.every((condition) => {
      if (typeof condition === "function") {
        return condition();
      }
      return !!document.querySelector(condition);
    });
    if (allConditionsMet) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - startTime >= maxTime) {
      clearInterval(interval);
    }
  }, POLLING_INTERVAL);
};

window.onload = (event) => {
  const inputElement = document.getElementById("typewriter-input");
  const staticPlaceholder = "Suche nach ";
  const textParts = ["Rollator", "Elektromobile", "Zubehör Mobilität"];

  let partIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  const typingSpeed = 100;
  const pauseDuration = 2000;

  function updatePlaceholder() {
    const currentPart = textParts[partIndex];
    const textToShow = isDeleting
      ? currentPart.substring(0, charIndex - 1)
      : currentPart.substring(0, charIndex + 1);

    // inputElement.placeholder = staticPlaceholder + textToShow;

    if (isDeleting) {
      charIndex--;
    } else {
      charIndex++;
    }

    if (charIndex === currentPart.length) {
      isDeleting = true;
      setTimeout(updatePlaceholder, pauseDuration);
    } else if (charIndex === 0 && isDeleting) {
      isDeleting = false;
      partIndex = (partIndex + 1) % textParts.length;
      setTimeout(updatePlaceholder, pauseDuration);
    } else {
      setTimeout(updatePlaceholder, typingSpeed);
    }
  }

  updatePlaceholder();

  jQuery(function () {
    jQuery(".searchenableTwo").click(function () {
      jQuery("#searchprdct2").removeClass("disabled");
      jQuery("#searchprdct1").addClass("active");
      jQuery("#searchprdct04").removeClass("disabled");
      jQuery(".opt1").text(jQuery(this).attr("dataName"));
      jQuery(".clear_home_searchBx").removeClass("d-none");
      jQuery("#maincat").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategory").val(jQuery(this).attr("dataURl"));
      jQuery("#searchcategoryh").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
      jQuery("#searchprdct2").click();
    });
  });

  jQuery(function () {
    jQuery(".searchenableThree").click(function () {
      jQuery("#searchprdct3").removeClass("disabled");
      jQuery("#searchprdct2").addClass("active");
      jQuery(".opt2").text(jQuery(this).attr("dataName"));
      jQuery("#subcat").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategory").val(jQuery(this).attr("dataURl"));
      jQuery("#searchcategoryh").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
      jQuery("#searchprdct3").click();
    });
  });

  jQuery(function () {
    jQuery(".searchenableTwo").click(function () {
      jQuery("#searchprdct6").removeClass("disabled");
      jQuery("#searchprdct08").removeClass("disabled");
      jQuery("#searchprdct5").addClass("active");
      jQuery(".opt1").text(jQuery(this).attr("dataName"));
      jQuery("#maincatmbl").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategorymbl").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
    });
  });

  jQuery(function () {
    jQuery(".searchenableThree").click(function () {
      jQuery("#searchprdct7").removeClass("disabled");
      jQuery("#searchprdct6").addClass("active");
      jQuery(".opt2").text(jQuery(this).attr("dataName"));
      jQuery("#subcatmbl").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategorymbl").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
    });
  });

  jQuery(".clearsrchsval").click(function (e) {
    e.preventDefault();
    //document.getElementsByClassName("opt1").innerHTML = "Happy Birthday!"
    jQuery(".opt1").text("Gesuchtes Produkt");
    jQuery(".opt2").text("Verfeinern Sie Ihre Suche");
    jQuery(".opt3").text("Weitere Optionen");
    jQuery("#searchprdct2").addClass("disabled");
    jQuery("#searchprdct3").addClass("disabled");
    jQuery("#searchprdct04").addClass("disabled");
    jQuery("#searchprdct1").removeClass("active");
    jQuery("#searchprdct2").removeClass("active");
    jQuery("#searchprdct6").addClass("disabled");
    jQuery("#searchprdct7").addClass("disabled");
    jQuery("#searchprdct08").addClass("disabled");
    jQuery("#searchprdct5").removeClass("active");
    jQuery("#searchprdct6").removeClass("active");
    jQuery(".hidden-val").val("");
    jQuery(".hidden-val").focus();
    jQuery("#searchprdct6").removeClass("active");
    jQuery(".clear_home_searchBx").addClass("d-none");
  });

  var close_container = $(".search_toggleDiv");
  $(".close_search_h").on("click", function (e) {
    close_container.fadeOut();
  });

  function loadContent(pageHandle) {
    // var urldata='https://networcare.myshopify.com'+$("#searchcategory").val();
    // if($("#searchqueary").val()!=''){
    //     urldata=urldata+$("#searchqueary").val();
    // }else{
    //   urldata=urldata+'?view=ajax';
    // }
    fetch(
      "https://samado.shop" +
        $("#searchcategory").val() +
        "?view=ajax",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => response.text())
      .then((html) => {
        // console.log(html);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        console.log('doc ',doc);
        const newProductGrid = doc.getElementById("facetDataHome").innerHTML;
        console.log('newProductGrid : ',newProductGrid);
        console.log(doc.getElementById("facetDataHome").length);
        if (
          newProductGrid.includes("Keine Variationen Verfügbar") ||
          newProductGrid.includes("keine variationen verfügbar")
        ) {
          $("#searchprdct3").addClass("disabled");
          $("#searchprdct3").addClass("remove");
        }
        // if(doc.getElementById('facetDataHome').length>1){
        //   jQuery("#main-collection-filters").html(newProductGrid);
        // }else{
        //    $("#searchprdct3").addClass("disable");
        //    $("#searchprdct3").addClass("remove");
        // }

        jQuery("#main-collection-filters").html(newProductGrid);
      })
      .catch((error) => console.error("Error here:", error));
  }

  jQuery(".searchprdctpop-target").fadeOut();
  jQuery(function () {
    jQuery(".search-single").click(function () {
      if (!jQuery(this).hasClass("disabled")) {
        /*parseInt(jQuery(this).attr("search-target"))+1;
                  jQuery('#searchprdct2').removeClass('disabled');*/
        jQuery(".searchprdctpop-target").fadeOut();
        jQuery("#searchprdctpop" + $(this).attr("search-target")).fadeIn();
        if (parseInt(jQuery(this).attr("search-target")) == 1) {
          jQuery("#searchprdct2").addClass("disabled");
          jQuery("#searchprdct2").removeClass("active");
          jQuery("#searchprdct3").addClass("disabled");
          jQuery("#searchprdct3").removeClass("active");
          jQuery("#searchprdct04").addClass("disabled");
          jQuery(".opt2").text("Verfeinern Sie Ihre Suche");
          jQuery(".opt3").text("Weitere Optionen ");
          jQuery("#searchqueary").val("");
          jQuery("#searchcategoryh").val("");
        }

        if (parseInt(jQuery(this).attr("search-target")) == 2) {
          jQuery("#searchprdct3").addClass("disabled");
          jQuery("#searchprdct3").removeClass("active");
          jQuery("#searchprdct04").removeClass("disabled");
          jQuery(".opt3").text("Weitere Optionen ");
          jQuery("#searchqueary").val("");
        }

        maincatID = jQuery("#maincat").val();
        console.log("main cat", maincatID);
        jQuery(".searchenableThree").hide();
        jQuery(".prnt-" + maincatID).css("display", "block");
      }
      //jQuery('.cart-single').removeClass('active');
      //jQuery('#cartmenu'+$(this).attr('search-target')).addClass('active');
    });
  });

  $(".buttonforsearch").click(function (e) {
    if (!$(this).hasClass("disabled")) {
      // if($("#searchqueary").val()==''){
      //    window.location.href=$("#searchcategory").val()+$("#searchqueary").val()
      // }else{
      //    window.location.href=$("#searchcategory").val()+$("#searchqueary").val()
      // }
      window.location.href =
        $("#searchcategory").val() + $("#searchqueary").val();
    }
  });
  $(document).mouseup(function (e) {
    var container = $(".search_toggleDiv");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
    }
  });

  var containers = $(".search_toggleDiv");
  $(".searchPrdctListBx").on("click", function (e) {
      e.preventDefault();
    containers.fadeOut();
  });

  // setTimeout(function () {
  //   jQuery(function () {
  //     jQuery("select.select6").each(function () {
  //       jQuery(this).select2({
  //         //theme: 'bootstrap4',
  //         //minimumResultsForSearch: -1,
  //         width: "100%",
  //         closeOnSelect: true,
  //         allowClear: false,
  //         placeholder: jQuery(this).attr("placeholder"),
  //         //allowClear: Boolean(jQuery(this).data('allow-clear')),
  //         dropdownParent: $("#locations"),
  //       });
  //     });
  //   });
  // }, 500);

  // const swiper6 = new Swiper(".recomendation_slides", {
  //   slidesPerView: 1,
  //   spaceBetween: 16,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //              el: '.swiper-pagination',
  //            },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper = new Swiper(".hme_partnersSldr", {
  //   slidesPerView: 7,
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /* pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     576: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //     992: {
  //       slidesPerView: 7,
  //       spaceBetween: 10,
  //     },
  //   },
  //   // And if we need scrollbar
  //   /* scrollbar: {
  //               el: '.swiper-scrollbar',
  //             },*/
  // });

  // const swiper2 = new Swiper(".hme_popularPrdctsSldr", {
  //   slidesPerView: "auto",
  //   spaceBetween: 16,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper3 = new Swiper(".leading_storeSlides", {
  //   slidesPerView: "auto",
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /* pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   /*breakpoints: {
  //                   320: {
  //                     slidesPerView: 1,
  //                     spaceBetween: 10,
  //                   },
  //                   576: {
  //                     slidesPerView: 2,
  //                     spaceBetween: 10,
  //                   },
  //                   768: {
  //                     slidesPerView: 2,
  //                     spaceBetween: 10,
  //                   },
  //                   992: {
  //                     slidesPerView: 7,
  //                     spaceBetween: 10,
  //                   },
  //               },*/
  //   // And if we need scrollbar
  //   /* scrollbar: {
  //               el: '.swiper-scrollbar',
  //             },*/
  // });

  // const swiper4 = new Swiper(".wheelchair_prdctSlder", {
  //   slidesPerView: 1,
  //   spaceBetween: 10,
  //   freeMode: true,
  //   loop: true,
  //   centeredSlides: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper5 = new Swiper(".wheelchair_prdctSldesPrdct", {
  //   slidesPerView: 1,
  //   centeredSlides: true,
  //   spaceBetween: 10,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper8 = new Swiper(".jahren_onlineSlidr", {
  //   //slidesPerView: 1,
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: 1,
  //       spaceBetween: 10,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper9 = new Swiper(".unser_antriebBoxesSldes", {
  //   slidesPerView: "auto",
  //   spaceBetween: 20,
  //   freeMode: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     992: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     1200: {
  //       slidesPerView: "auto",
  //       spaceBetween: 20,
  //     },
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  pollerLite(
    [".suitable_acess_Sldr", () => $(".suitable_acess_Sldr").length > 0],
    () => {
      new Swiper(".suitable_acess_Sldr", {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  );

  $(document).on("click", ".simpAskQuestionForm-btnOpen", function () {
    $(".simpAskSubmitForm > .button").val("Abschicken");
    $(".simpAskForm-cancel-btn").text("Abberchen");
    $("input.simpAsk-fifty-percent[name=name]").attr("placeholder", "Ihr Name");
    $("input.simpAsk-fifty-percent[name=email]").attr(
      "placeholder",
      "Ihr Email"
    );
    $("textarea[name=question]").attr("placeholder", "Stellen Sie eine Frage");
  });

  $(".add").click(function () {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  });
  $(".sub").click(function () {
    if ($(this).next().val() > 0)
      $(this)
        .next()
        .val(+$(this).next().val() - 1);
  });

  $(".nav-tabs-selector").on("change", function (e) {
    var atthis = "#nav-"+$(this).val();
    $(this).closest(".popular_prdcts_sect").find(".tab-pane").removeClass("show active");
    $(atthis).addClass("show active");
    $(this).closest(".popular_prdcts_sect").find(".nav-tabs ul li a").eq($(this).val()).tab("show");
  });

  if ($(window).width() < 1200) {
    $(".footer_links h6").click(function () {
      $(this).next(".footer_links ul").slideToggle();
      $(this).toggleClass("tglesldr");
    });
    $(".popular_prdctsColorAvail--drop h3").click(function () {
      $(this).next(".popular_prdctsColorAvailLstng").slideToggle();
      $(this).toggleClass("tglesldr");
    });
  }

  $(".color-swatch").hover(function () {
    prodid = $(this).attr("prodid");
    matchingdata = $(this).attr("val");
    finded = false;
    if ($(".img-" + prodid).length > 0) {
      $(".img-" + prodid).each(function () {
        datatitle = $(this).attr("datatitle").toLowerCase();
        if (finded == false) {
          if (datatitle.includes(matchingdata.toLowerCase())) {
            $(".img-" + prodid).css("display", "none");
            $(this).css("display", "block");
            $("#mainimage" + prodid).css("display", "none");

            finded = true;
          }
        }
      });
    } else {
      $("#mainimage" + prodid).css("display", "block");
    }
  });

  $(document).on("click", ".epr-collaps-btn", function () {
    $("#description").siblings(".form-label").text("Bewertung Beschreibung");
    $("#description").prop("required", false);
    $("#title").prop("required", true);
    $("#title")
      .siblings(".form-label")
      .html("Titel der Bewertung<span style='color:red'>*</span>");
  });

  $(document).on("change", "#location_serach", function () {
    if ($(this).val() != "") {
      $(".locationsubmit").prop("disabled", false);
    } else {
      $(".locationsubmit").prop("disabled", true);
    }
  });

  $("#status_checkBxOne").on("click", function () {
    $("#status_checkBxTwo").addClass("status_checkBx--offline");
    $("#status_checkBxOne").removeClass("status_checkBx--offline");
    $(".market_location_description").show();
    $(".selected_location_lable").html("");
    $("#pickupstore").val("");

    // Access the Select2 container
    var $select2Container = $("#location_serach").data("select2").$dropdown;
    // Find and clear the search input field
    var $searchInput = $select2Container.find("input.select2-search__field");
    $searchInput.val("").trigger("input");
    // Optionally, clear selection
    $("#location_serach").val(null).trigger("change");
  });

  $(document).on("click", ".locationsubmit", async function () {
    if ($("#location_serach").length > 0 && $("#location_serach").val() != "") {
      $("#pickupstore").show();
      $("#pickupstore").val($("#location_serach").val());
      $(".status_checkBx").removeClass("status_checkBx--offline");
      $(".status_checkBx").first().addClass("status_checkBx--offline");
      $(".market_location_description").hide();
      $(".selected_location_lable").html($("#location_serach").val());
      $("#locations").modal("hide");
    }
  });
};

// Auto select the size 
function selectVariantOnPriceMatch() {
  const priceElement = document.querySelector(".product-info__sticky span._ks_text b");

  if (priceElement) {
    const priceValue = priceElement.innerHTML.trim();

    document.querySelectorAll("sticky-scroll-direction fieldset input").forEach(input => {
      if (input.value.trim() === priceValue) {
        const label = input.nextElementSibling;

        if (label && label.tagName.toLowerCase() === "label") {
          const labelTitle = label.getAttribute("title");
          const blockedTitles = ["Unavailable", "Sold out", "Nicht verfügbar", "Ausverkauft"];

          if (blockedTitles.includes(labelTitle)) {
            const fieldset = input.closest("fieldset");
            const fallbackInput = fieldset?.querySelector('input:not(.is-unavailable)');
            const fallbackLabel = fallbackInput && fieldset?.querySelector(
              `label[for="${fallbackInput.id}"]:not([title="Unavailable"]):not([title="Sold out"]):not([title="Nicht verfügbar"]):not([title="Ausverkauft"])`
            );

            if (fallbackInput && fallbackLabel) {
              fallbackLabel.click();
            }
          } else {
            label.click();
          }
        }
      }
    });
  } else {
    // Fallback when price element is not found
    const fieldsets = document.querySelectorAll("sticky-scroll-direction fieldset");
    let allPreselectedValid = true;

    fieldsets.forEach(fieldset => {
      if (fieldset.getAttribute("option_name") === "Farbe") return;

      const selectedInput = fieldset.querySelector("input:checked");
      const selectedLabel = selectedInput && fieldset.querySelector(`label[for="${selectedInput.id}"]`);
      const labelTitle = selectedLabel?.getAttribute("title");

      const isBlocked = ["Unavailable", "Sold out", "Nicht verfügbar", "Ausverkauft"].includes(labelTitle);

      if (!selectedInput || !selectedLabel || isBlocked) {
        allPreselectedValid = false;
      }
    });

    // Only run fallback if at least one fieldset is not valid
    if (!allPreselectedValid) {
      console.warn("Price element not found, selecting first available variant");

      fieldsets.forEach(fieldset => {
        if (fieldset.getAttribute("option_name") === "Farbe") return;

        const fallbackInput = fieldset.querySelector('input:not(.is-unavailable)');
        const fallbackLabel = fallbackInput && fieldset.querySelector(
          `label[for="${fallbackInput.id}"]:not([title="Unavailable"]):not([title="Sold out"]):not([title="Nicht verfügbar"]):not([title="Ausverkauft"])`
        );

        if (fallbackInput && fallbackLabel) {
          fallbackLabel.click();
        }
      });
    }
  }
}

// Attach event listeners to "Farbe" inputs
document.querySelectorAll('fieldset[option_name="Farbe"] input').forEach(input => {
  input.addEventListener("click", () => {
    setTimeout(selectVariantOnPriceMatch, 250);
  });
});

// Initial call after a short delay
setTimeout(selectVariantOnPriceMatch, 2500);

// Observe dynamic DOM changes to re-attach listeners or re-select variants
const observer = new MutationObserver(() => {
  const inputFields = document.querySelectorAll(".kiwi-sizing-modal input.element-input[type='number']");

  if (inputFields.length < 1) {
    // selectVariantOnPriceMatch();
  } else {
    inputFields.forEach(input => {
      input.addEventListener("change", selectVariantOnPriceMatch);
    });
  }
});

// Start observing the document for changes
observer.observe(document.body, { childList: true, subtree: true });

// Close moga menu when mouse leave
// FIX: .js-mega-nav wird in diesem Theme nie gerendert (header.liquid:232
// haengt die Klasse an {% if mega_nav %}, und der mega_menu_full-Block hat
// kein title-Setting, sodass der Titelvergleich nie trifft). megaNav war
// damit immer null, die forEach warf einen TypeError auf oberster
// Script-Ebene — und alles ab hier (map-integration, rezept-erfassen,
// product-timer, Click- und DOMContentLoaded-Handler) wurde nie definiert.
// Der Guard stellt die Ausfuehrung des restlichen Files wieder her.
const mainNav = document.querySelector('.main-nav');
const megaNav = document.querySelector('.js-mega-nav');

if (mainNav && megaNav) {
  [mainNav, megaNav].forEach(el => {
    el.addEventListener('mouseleave', () => {
      megaNav.classList.remove('is-open');
      megaNav.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    });
  });
}

class MapIntegration extends HTMLElement {
  constructor() {
    super();
    this.map = null;
    this.infoWindow = null;
    this.currentInfoWindow = null;
    this.markers = [];
    this.customLocations = [];
  }

  connectedCallback() {
    this.initElements();
    this.initMap();
    this.attachEventListeners();
  }

  initElements() {
    this.mapElement = this.querySelector("#map");
    this.searchBar = this.querySelector("#search-bar");
    this.resultsContainer = this.querySelector("#autocomplete-results");
    this.locationLogo = this.querySelector("#store_location_logo");
    this.locationTile = this.querySelector("#store_location_tile");
    this.locationAddress = this.querySelector("#store_location_address");
    this.locationPhone = this.querySelector("#store_location_phone");
    this.locationEmail = this.querySelector("#store_location_email");
    this.locationWebsite = this.querySelector("#store_location_website");
    this.bookingBtn = this.querySelector('.vereinbaren-btn');
    this.bookingForm = document.querySelector("#store_booking_form");
  }

  async initMap() {
    this.customLocations = window.nm.locations;
    const germanyCenter = { lat: 51.1657, lng: 10.4515 };

    this.map = new google.maps.Map(this.mapElement, {
      zoom: 6,
      center: germanyCenter,
      mapTypeControl: false,
      draggable: true,
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: true,
    });

    this.infoWindow = new google.maps.InfoWindow();
    this.addMarkers();
  }

  addMarkers() {
    this.markers = this.customLocations.map((location) => {
      const position = new google.maps.LatLng(
        parseFloat(location.latitude),
        parseFloat(location.longitude)
      );

      const marker = new google.maps.Marker({
        position,
        map: this.map,
        title: location.label,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0574/1350/1024/files/map-location-marker-93567c.png?v=1728923405", // Image URL
          scaledSize: new google.maps.Size(40, 40), // Scaled size
          origin: new google.maps.Point(0, 0), // Origin of the image
          anchor: new google.maps.Point(25, 40), // Anchor point of the image
        },
      });

      marker.addListener("click", () => this.onMarkerClick(marker, location));
      return marker;
    });

    new markerClusterer.MarkerClusterer({
      map: this.map,
      markers: this.markers,
      maxZoom: 6,
    });
  }

  onMarkerClick(marker, location) {
    if (this.currentInfoWindow) this.currentInfoWindow.close();

    this.infoWindow.setContent(`
      <div class="info-window">
          <h3>${location.label}</h3>
          <p><strong>Adresse:</strong> ${location.street}, ${location.zip_code} ${location.city}</p>
          <p><strong>Tel.:</strong> ${location.phone}</p>
          <p><a href="${location.url}" target="_blank">Website</a></p>
      </div>
    `);
    this.infoWindow.open(this.map, marker);

    this.updateLocationDetails(location);
    this.currentInfoWindow = this.infoWindow;
  }

  updateLocationDetails(location) {
    this.locationTile.textContent = location.label || "";
    this.locationAddress.textContent =
      `${location.street}, ${location.zip_code} ${location.city}` || "";
    this.locationPhone.textContent = location.phone || "";
    this.locationPhone.href = location.phone ? `tel:${location.phone}` : "";
    this.locationEmail.textContent = location.email || "";
    this.locationEmail.href = location.email ? `mailto:${location.email}` : "";
    this.locationWebsite.textContent = location.url || "";
    this.locationWebsite.href = location.url || "";
    if(location.meeting_url) this.updateMeetingURL(location.meeting_url);
    // if (location.meeting_url) {
    //   this.bookingBtn.href = location.meeting_url;

    //   if (this.bookingBtn.hasAttribute("data-bs-toggle")) {
    //     this.bookingBtn.removeAttribute("data-bs-toggle");
    //   }
    // } else {
    //   this.bookingBtn.href = "#calendar_popup";

    //   if (!this.bookingBtn.hasAttribute("data-bs-toggle")) {
    //     this.bookingBtn.setAttribute("data-bs-toggle", "modal");
    //   }
    // }
    this.updateLocationLogo(location.logo);
  }

  updateLocationLogo(logo) {
    if (!logo) {
      this.locationLogo.style.display = "none";
      this.locationLogo.src = "";
      return;
    }
    this.locationLogo.style.display = "block";
    this.locationLogo.src = logo;
  }

  updateMeetingURL(src) {
    if (!src) return; 

    if(src.startsWith("mailto:")) {
      this.bookingBtn.href = src
      this.bookingBtn.removeAttribute("data-bs-toggle");
    } else {
      this.bookingBtn.href = "#calendar_popup"
      this.bookingBtn.setAttribute("data-bs-toggle", "modal");
      
      const iframeEle = document.querySelector('#calendar_popup #store_booking_form');
      if (iframeEle) {
        iframeEle.src = src;
      }
    }
  }

  attachEventListeners() {
    this.searchBar.addEventListener("input", () => this.onSearch());
  }

  onSearch() {
    const searchTerm = this.searchBar.value.toLowerCase();
    this.resultsContainer.innerHTML = "";

    if (!searchTerm) {
      this.addMarkers();
      return;
    }

    const filteredLocations = this.customLocations.filter((location) => {
      const fullAddress =
        `${location.label} ${location.street} ${location.zip_code} ${location.city}`.toLowerCase();
      return fullAddress.includes(searchTerm);
    });

    filteredLocations.forEach((location) => {
      const resultItem = document.createElement("div");
      resultItem.classList.add("autocomplete-item");
      resultItem.textContent = `${location.label} ${location.street} ${location.zip_code} ${location.city}`;
      resultItem.addEventListener("click", () => this.selectLocation(location));
      this.resultsContainer.appendChild(resultItem);
    });
  }

  selectLocation(location) {
    const position = new google.maps.LatLng(
      parseFloat(location.latitude),
      parseFloat(location.longitude)
    );
    this.map.setCenter(position);
    this.map.setZoom(12);

    this.searchBar.value = location.label;
    this.resultsContainer.innerHTML = "";

    const selectedMarker = this.markers.find(
      (marker) =>
        marker.getPosition().lat() === position.lat() &&
        marker.getPosition().lng() === position.lng()
    );

    if (selectedMarker) {
      this.infoWindow.setContent(`
        <div class="info-window">
          <h3>${location.label}</h3>
          <p><strong>Adresse:</strong> ${location.street}, ${location.zip_code} ${location.city}</p>
          <p><strong>Tel.:</strong> ${location.phone}</p>
          <p><a href="${location.url}" target="_blank">Website</a></p>
        </div>
      `);
      this.infoWindow.open(this.map, selectedMarker);

      this.currentInfoWindow = this.infoWindow;
    }

    this.updateLocationDetails(location);
  }
}
customElements.define("map-integration", MapIntegration);

// class RezeptErfassen extends HTMLElement {
//   constructor() {
//     super();
//     this.serviceID = "service_e33bdl2";
//     this.publicKey = "0JVngWg6930HJlkVF";
//     this.templateID = "template_9trrv3p";
//   }

//   connectedCallback() {
//     emailjs.init(this.publicKey);

//     this.fileInput = this.querySelector("#file-upload-input");
//     this.fileUploadBtn = this.querySelector(".file-select-button");
//     this.fileNameDisplay = this.querySelector(".files-select-name");
//     this.vorname = this.querySelector("input[name='vorname']");
//     this.nachname = this.querySelector("input[name='nachname']");
//     this.location = this.querySelector("select[name='location']");
//     this.email = this.querySelector("input[name='email']");
//     this.telefonnummer = this.querySelector("input[name='telefonnummer']");
//     this.locationForm = this.querySelector("#location-form");
//     this.errorMessages = this.querySelector("#fileupload_popup #error-mesages");
//     this.mapLoader = this.querySelector(".fileupload-spinner");
//     this.contentWrapper = this.querySelector(".fileupload_popupWrap");

//     if (this.fileUploadBtn) {
//       this.fileUploadBtn.addEventListener("click", () => {
//         this.fileInput.click();
//       });
//     }

//     if (this.fileInput) {
//       this.fileInput.addEventListener(
//         "change",
//         this.handleFileInputChange.bind(this)
//       );
//     }

//     if (this.locationForm) {
//       this.locationForm.addEventListener(
//         "submit",
//         this.handleFormSubmit.bind(this)
//       );
//     }
//   }

//   handleFileInputChange() {
//     if (this.fileInput.files.length > 0) {
//       this.fileNameDisplay.textContent = this.fileInput.files[0].name;
//     } else {
//       this.fileNameDisplay.textContent = "Rezept Upload";
//     }
//   }

//   handleFormSubmit(event) {
//     event.preventDefault();
    
//     const selectedLocation = this.location.options[this.location.selectedIndex];
//     if (selectedLocation) {
//             this.querySelector("#to_email").value = selectedLocation.getAttribute("datastoreemail");
//     }    

//     if (this.contentWrapper) this.contentWrapper.classList.add('hidden');
//     if (this.mapLoader) this.mapLoader.classList.remove('hidden');
//     emailjs.sendForm(this.serviceID, this.templateID, this.locationForm)
//       .then((response) => {
//         if (this.mapLoader) this.mapLoader.classList.add('hidden');
//         if (this.contentWrapper) this.contentWrapper.classList.remove('hidden');

//         this.errorMessages.innerHTML = `<div class="alert alert-success" role="alert">Ihr Rezept wurde erfolgreich an die Filiale übermittelt.<br><strong>In Kürze wird sich bei Ihnen ein Mitarbeiter melden und sich persönlich um Ihre Versorgung kümmern. Bitte nehmen Sie für die Filiale Ihr Originalrezept mit.</strong></div>`;
//         this.locationForm.style.display = "none";

//         setTimeout(() => {
//           this.locationForm.reset();
//           this.locationForm.style.display = "block";
//           this.errorMessages.innerHTML = "";
//         }, 6000);
//       })
//       .catch((error) => {
//         if (this.mapLoader) this.mapLoader.classList.add('hidden');
//         if (this.contentWrapper) this.contentWrapper.classList.remove('hidden');
//         this.errorMessages.innerHTML = `<div class="alert alert-danger" role="alert">Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.</div>`;
//         console.error("EmailJS Error:", error);
//       });
//   }
// }
// customElements.define("rezept-erfassen", RezeptErfassen);
class RezeptErfassen extends HTMLElement {
  constructor() {
    super();
    this.serviceID = "service_e33bdl2";
    this.publicKey = "0JVngWg6930HJlkVF";
    this.templateID = "template_9trrv3p";
    this.storeData = window.nm.locations || [];
    this.selectedStoreLabel = null;
  }

  connectedCallback() {
    emailjs.init(this.publicKey);

    this.fileInput = this.querySelector("#file-upload-input");
    this.fileUploadBtn = this.querySelector(".form-fields-fileupload");
    this.fileNameDisplay = this.querySelector(".files-select-name");
    this.vorname = this.querySelector("input[name='vorname']");
    this.nachname = this.querySelector("input[name='nachname']");
    this.locationSelect = this.querySelector("#location");
    this.email = this.querySelector("input[name='email']");
    this.telefonnummer = this.querySelector("input[name='telefonnummer']");
    this.locationForm = this.querySelector("#location-form");
    this.errorMessages = this.querySelector("#fileupload_popup #error-mesages");
    this.mapLoader = this.querySelector(".fileupload-spinner");
    this.contentWrapper = this.querySelector(".fileupload_popupWrap");
    this.zipInput = this.querySelector("#postcode");
    this.findStoreButton = this.querySelector("#button-filialefinden");
     this.result_append = this.querySelector(".result_append");
    this.storeResult = document.createElement("div");
    this.storeResult.className = "store-results";

    this.result_append.appendChild(this.storeResult);

    if (this.fileUploadBtn) {
      this.fileUploadBtn.addEventListener("click", () => {
        this.fileInput.click();
      });
    }

    if (this.fileInput) {
      this.fileInput.addEventListener("change", this.handleFileInputChange.bind(this));
    }

   if (this.findStoreButton) {
    this.findStoreButton.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent form submission
        this.findNearestStore();
    });
}
    if (this.locationForm) {
      this.locationForm.addEventListener("submit", this.handleFormSubmit.bind(this));
    }
  }

  handleFileInputChange() {
    this.fileNameDisplay.textContent = this.fileInput.files.length > 0
      ? this.fileInput.files[0].name
      : "Rezept Upload";
  }

  findNearestStore() {
    const zipCode = this.zipInput.value.trim();
    
    if (!zipCode || zipCode.length !== 5) {
      this.autoSelectDefaultLocation();
      this.storeResult.innerHTML = `<p style="color: red;">Bitte eine gültige Postleitzahl eingeben.</p>`;
      return;
    }
    
    const sortedStores = this.storeData
      .filter(store => store.zip_code && store.label !== "Warenbestand Online")
      .map(store => ({
        ...store,
        distance: Math.abs(parseInt(store.zip_code, 10) - parseInt(zipCode, 10))
      }))
      .sort((a, b) => a.distance - b.distance);

    if (sortedStores.length > 0) {
      this.autoSelectLocationByLabel(sortedStores[0].label);
      this.selectedStoreLabel = sortedStores[0].label;
    }
    
    this.storeResult.innerHTML = this.generateStoreDetails(sortedStores.slice(0, 2));
  }

  autoSelectLocationByLabel(storeLabel) {
    if (!this.locationSelect) return;

    const foundOption = Array.from(this.locationSelect.options).find(
      option => option.textContent.trim() === storeLabel
    );

    if (foundOption) {
      this.locationSelect.value = foundOption.value;
      this.selectedStoreLabel = storeLabel;
      this.updateStoreHighlight();
    }
  }

  autoSelectDefaultLocation() {
    if (this.locationSelect) {
      this.locationSelect.selectedIndex = 0;
      this.selectedStoreLabel = null;
      this.updateStoreHighlight();
    }
  }

  generateStoreDetails(stores) {
    return stores
      .map(
        store => `
        <div class="store-details ${this.selectedStoreLabel === store.label ? 'selected' : ''}" data-label="${store.label}">
          <span class="location-check-icon"></span>
          <img src="${store.logo}" alt="${store.label}" style="max-width: 150px;">
          <h5>${store.label}</h5>
          <p><strong>Adresse:</strong> ${store.street}, ${store.city}, ${store.zip_code}, ${store.country}</p>
          <p><strong>Telefon:</strong> <a href="tel:${store.phone}">${store.phone}</a></p>
          <p><strong>Email:</strong> <a href="mailto:${store.email}">${store.email}</a></p>
          <p><strong>Mehr Infos:</strong> <a href="${store.url}" target="_blank">Hier klicken</a></p>
        </div>
      `
      )
      .join("");
  }

  updateStoreHighlight() {
    document.querySelectorAll(".store-details").forEach(storeElement => {
      const storeLabel = storeElement.getAttribute("data-label");
      storeElement.classList.toggle("selected", storeLabel === this.selectedStoreLabel);
    });
  }

  handleFormSubmit(event) {
    event.preventDefault();
    
    const selectedLocation = this.locationSelect.options[this.locationSelect.selectedIndex];
    const toEmailField = this.querySelector("#to_email");
    if (toEmailField && selectedLocation) {
      toEmailField.value = selectedLocation.getAttribute("datastoreemail");
    }

    if (!this.selectedStoreLabel) {
      this.errorMessages.innerHTML = `<div class="alert alert-danger">Bitte wählen Sie eine Filiale aus.</div>`;
      return;
    }

    if (this.contentWrapper) this.contentWrapper.classList.add('opacity_hide');
    if (this.mapLoader) this.mapLoader.removeAttribute('hidden');
    emailjs.sendForm(this.serviceID, this.templateID, this.locationForm)
      .then(() => {
        this.mapLoader.setAttribute("hidden", "true");
        this.contentWrapper.classList.remove('opacity_hide');
        this.errorMessages.innerHTML = `<div class="alert alert-success">Ihr Rezept wurde erfolgreich übermittelt.</div>`;
        this.locationForm.style.display = "none";
        setTimeout(() => {
          this.locationForm.reset();
          this.locationForm.style.display = "block";
          this.errorMessages.innerHTML = "";
        }, 6000);
      })
      .catch(() => {
        this.mapLoader.setAttribute("hidden", "true");
        this.contentWrapper.classList.remove('opacity_hide');
        this.errorMessages.innerHTML = `<div class="alert alert-danger">Ein Fehler ist aufgetreten.</div>`;
      });
  }
}

customElements.define("rezept-erfassen", RezeptErfassen);

// Event listener for switching selection on store click
document.addEventListener("click", function (event) {
  const storeElement = event.target.closest(".store-details");
  if (storeElement) {
    const selectedLabel = storeElement.getAttribute("data-label");
    const rezeptComponent = document.querySelector("rezept-erfassen");

    if (rezeptComponent) {
      rezeptComponent.autoSelectLocationByLabel(selectedLabel);
    }
  }
});


class ProductTimer extends HTMLElement {
  constructor() {
    super();
    this.targetDate = this.getAttribute("data-date"); // Target date in dd/mm/yyyy
    this.targetTime = this.getAttribute("data-time"); // Target time (e.g., '1pm')
    this.timer = null;
    this.lastValues = { days: null, hours: null, minutes: null, seconds: null };
  }

  connectedCallback() {
    this.daysElement = this.querySelector("#countdownDays");
    this.hoursElement = this.querySelector("#countdownHours");
    this.minutesElement = this.querySelector("#countdownMin");
    this.secondsElement = this.querySelector("#countdownSec");

    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown() {
    const endDate = this.parseDateTime(this.targetDate, this.targetTime);
    if (!endDate) {
      console.error("Invalid date or time format. Please use dd/mm/yyyy and a valid time format (e.g., '1pm').");
      return;
    }

    const endTime = endDate.getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const remainingTime = endTime - now;

      if (remainingTime < 0) {
        this.clearTimer();
        return;
      }

      const days = Math.floor(remainingTime / ProductTimer._day);
      const hours = Math.floor(
        (remainingTime % ProductTimer._day) / ProductTimer._hour
      );
      const minutes = Math.floor(
        (remainingTime % ProductTimer._hour) / ProductTimer._minute
      );
      const seconds = Math.floor(
        (remainingTime % ProductTimer._minute) / ProductTimer._second
      );

      this.updateDisplay(days, hours, minutes, seconds);

      this.timer = requestAnimationFrame(updateTimer);
    };

    updateTimer(); // Initial update
  }

  updateDisplay(days, hours, minutes, seconds) {
    const { lastValues } = this;

    if (this.daysElement && days !== lastValues.days) {
      this.daysElement.textContent = days;
      lastValues.days = days;
    }
    if (this.hoursElement && hours !== lastValues.hours) {
      this.hoursElement.textContent = hours;
      lastValues.hours = hours;
    }
    if (this.minutesElement && minutes !== lastValues.minutes) {
      this.minutesElement.textContent = minutes;
      lastValues.minutes = minutes;
    }
    if (this.secondsElement && seconds !== lastValues.seconds) {
      this.secondsElement.textContent = seconds;
      lastValues.seconds = seconds;
    }
  }

  clearTimer() {
    if (this.timer) {
      cancelAnimationFrame(this.timer);
      this.timer = null;
    }
    this.updateDisplay(0, 0, 0, 0);
  }

  parseDateTime(dateString, timeString) {
    if (!dateString) return null;

    const [day, month, year] = dateString.split("/").map(Number);
    if (
      isNaN(day) ||
      isNaN(month) ||
      isNaN(year) ||
      day < 1 ||
      day > 31 ||
      month < 1 ||
      month > 12
    ) {
      return null; // Invalid date
    }

    let timeParts = this.parseTime(timeString);
    if (!timeParts) {
      return null; // Invalid time
    }

    // Combine date and time into a single Date object
    return new Date(year, month - 1, day, timeParts.hours, timeParts.minutes);
  }

  parseTime(timeString) {
    if (!timeString) return { hours: 0, minutes: 0 }; // Default to midnight if no time is provided

    const timeRegex = /(\d+)(?::(\d+))?\s*(am|pm)?/i;
    const match = timeString.match(timeRegex);

    if (!match) {
      return null; // Invalid time format
    }

    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10) || 0;
    const period = match[3] ? match[3].toLowerCase() : null;

    if (period === "pm" && hours < 12) {
      hours += 12;
    } else if (period === "am" && hours === 12) {
      hours = 0;
    }

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return null; // Invalid time values
    }

    return { hours, minutes };
  }

  static get _second() {
    return 1000;
  }
  static get _minute() {
    return this._second * 60;
  }
  static get _hour() {
    return this._minute * 60;
  }
  static get _day() {
    return this._hour * 24;
  }
}

// Define the custom element

customElements.define("product-timer", ProductTimer);

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const textElement = document.querySelector(
      "etrusted-rc-carousel-review-tile.review-tile-reduced .content .text"
    );
    if (textElement) {
      textElement.style.fontWeight = "400";
      console.log("Font-weight 400 applied to element.");
    } else {
      console.log("Element not found.");
    }
  }, 5000);
});